import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedMaterial } from '~/redux/slices/material';
import { selectZipcode } from '~/redux/slices/zipcode';
import { useDrawingShapeContext } from '~contexts';

export const useAreSinksAvailable = (): { areSinksAvailable: boolean } => {
  const zipcode = useAppSelector(selectZipcode);
  const {
    getters: { areThereShapesInTheDrawingArea },
  } = useDrawingShapeContext();
  const selectedStore = useSelectedStore();
  const selectedMaterial = useAppSelector(selectSelectedMaterial);

  return {
    areSinksAvailable:
      !!zipcode &&
      !!selectedStore &&
      !!selectedMaterial &&
      !!areThereShapesInTheDrawingArea,
  };
};
